import React, { useState, useEffect } from 'react'

import {
    useHistory
} from 'react-router-dom'

import { 
    Auth,
} from 'aws-amplify'

import NavBar from '../Components/Action/NavBar'

import AlertBox from '../Components/Action/AlertBox'

import { 
    PageDiv,
    WhiteDiv,
    HeaderDiv,
    Alert,
    Info
} from '../Styles/BaseStyles'

import { 
    ComponentsDiv,
    ViewerDiv
} from '../Styles/Pages/SettingsStyles'

import AccountSettingsSection from '../Components/Action/AccountSettingsSection'
import SubscriptionSettingsSection from '../Components/Action/SubscriptionSettingsSection'
import PasswordSettingsSection from '../Components/Action/PasswordSettingsSection'

import { 
    useSelector, 
    useDispatch 
} from 'react-redux'

import { 
    hideAlert,
    resetAlert as resetDropDownAlert
} from '../Redux/Slices/SettingsSlice'

import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'

function Settings(props){
    let history = useHistory()

    const dispatch = useDispatch()

    const [load, setLoad] = useState(false)

    const storage = useSelector(state => state.user.storage)

    const error = useSelector(state => state.settings.error)
    const errorPhrase = useSelector(state => state.settings.errorPhrase)
    const info = useSelector(state => state.settings.info)
    const infoPhrase = useSelector(state => state.settings.infoPhrase)

    const showAlert = useSelector(state => state.settings.showAlert)
    const alertType = useSelector(state => state.settings.alertType)

    const paymentRequired = useSelector(state => state.hub.paymentRequired)

    const [stripePromise, setStripePromise] = useState(() => loadStripe("pk_test_51I8ZRTDpPeaffYkrV6bVKOyaa4MNWs1McLjlDFM05bvXi0KRfac0ljLPkGQLoBitp1O6HWzR1E23tSH8sSsdGbbv00Rb3L9Jnh"))

    useEffect(() => {
        switch(storage){
            case 'localstorage':
                Auth.configure({storage: localStorage})
                break
            case 'sessionstorage':
                Auth.configure({storage: sessionStorage})
                break
            default:
                break
        }
        Auth.currentAuthenticatedUser().then(() => {
            setLoad(true)
        })
        .catch(() => {
            history.push('/login')
        })
    }, [])

    useEffect(() => {
        if(error || info){
            const timeId = setTimeout(() => {
                dispatch(resetDropDownAlert())
            }, 5000)
            return () => {
                clearTimeout(timeId)
            }
        }
    }, [dispatch,error,info])

    async function signout() {
        try {
            await Auth.signOut()
            sessionStorage.clear()
            localStorage.clear()
            history.push('/logoutconfirmation')
        } catch (error) {
            console.log(error)
        }
    }

    const verificationAlertInfo = {
        'alert_title': 'Account Not Verified', 
        'alert_phrase': 'In order to use QuickFiller services, you must verify your email and phone number. Please continue to Settings to complete the verification process or Log Out.', 
        'alert_type': 'action', 
        'primary_button_text': 'Complete Verification', 
        'primary_button_function': () => {
            dispatch(hideAlert())
        }, 
        'secondary_button_text': 'Logout', 
        'secondary_button_function': () => {
            dispatch(hideAlert())
            signout()
        },
        'style': {
            'alert_title': {
                'color': '#4267B2'
            }, 
            'alert_phrase': {}, 
            'primary_button': {}, 
            'secondary_button': {
                'color': 'red'
            }
        }
    }

    const subscriptionAlertInfo = {
        'alert_title': 'Account Not Subscribed', 
        'alert_phrase': 'In order to use QuickFiller services, you must select a subscription tier. Please continue to Settings to complete the subscription process or Log Out.', 
        'alert_type': 'action', 
        'primary_button_text': 'Complete Subscription', 
        'primary_button_function': () => {
            dispatch(hideAlert())
        }, 
        'secondary_button_text': 'Logout', 
        'secondary_button_function': () => {
            dispatch(hideAlert())
            signout()
        },
        'style': {
            'alert_title': {
                'color': '#4267B2'
            }, 
            'alert_phrase': {}, 
            'primary_button': {}, 
            'secondary_button': {
                'color': 'red'
            }
        }
    }

    const exitSubscribingAlertInfo = {
        'alert_title': 'Exit Subscription Process?', 
        'alert_phrase': 'Not selecting a subscription will prevent the use of QuickFiller services. Exiting will automatically log you out. ', 
        'alert_type': 'action', 
        'primary_button_text': 'Continue Subscribing', 
        'primary_button_function': () => {
            dispatch(hideAlert())
        }, 
        'secondary_button_text': 'Exit', 
        'secondary_button_function': () => {
            dispatch(hideAlert())
            signout()
        },
        'style': {
            'alert_title': {
                'color': '#4267B2'
            }, 
            'alert_phrase': {}, 
            'primary_button': {}, 
            'secondary_button': {
                'color': 'red'
            }
        }
    }

    var viewer = (
        <>
        </>
    )

    if(load){
        viewer = (
            <PageDiv>
                {(showAlert && alertType==='verification') && <AlertBox alertInfo = {verificationAlertInfo} />}
                {(showAlert && alertType==='subscription') && <AlertBox alertInfo = {subscriptionAlertInfo} />}
                {(showAlert && alertType==='exitSubscribing') && <AlertBox alertInfo = {exitSubscribingAlertInfo} />}
                <HeaderDiv>
                    <WhiteDiv>
                        <NavBar page="Settings"/>
                    </WhiteDiv>
                </HeaderDiv>
                <ComponentsDiv>
                    {error && <Alert style={{top: "0.5rem", position: "absolute"}}>{errorPhrase}</Alert>}
                    {info && <Info style={{top: "0.5rem", position: "absolute"}}>{infoPhrase}</Info>}
                    <ViewerDiv>
                        <AccountSettingsSection />
                        <PasswordSettingsSection />
                        {paymentRequired && <Elements stripe={stripePromise}>
                            <SubscriptionSettingsSection />
                        </Elements>}
                    </ViewerDiv>
                </ComponentsDiv>
            </PageDiv>
        )
    }

    return (
        <>
            {viewer}
        </>
    )
}

export default Settings